/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
import { useEffect, useState, useRef, useMemo, useContext } from "react";
import { useParams } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@repo/ui";
import { BiDownload, BiPrinter } from "react-icons/bi";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useGetJobCards } from "services/tickets";
import sweetAlert from "components/sweet-alert";
import { PATHS } from "routes/paths";
import { BreadCrumb } from "ui/bread-crumbs";
import Loader from "ui/page-loader";
import { StatusContext } from "../constants";
import { useGetParentTicketList, isCallCenterAgent } from "../utils";
import http from "services/http-client";
import { Button } from "@chakra-ui/react";
import { useUser } from "hooks/use-user";
import { useGetPanicAlertJobCards } from "services/panic-alert";

const dataCol1keys = [
  "ATM",
  "Card Reader",
  "Printer",
  "Dispenser",
  "Camera",
  "Key Pad",
  "ATM Cash Counter",
  "ATM AC",
  "Surroundings",
  "FDI Devices",
  "Suspect Foreign Device",
];
const dataCol2Keys = [
  "Cabinet Box-Equipments",
  "Pin Guard Status",
  "ATM Lock",
  "Machine Status",
];

export default function PanicAlertJobCards() {
  const [jobCardDetails, setJobCardDetails] = useState({});
  const [dataCol1, setDataCol1] = useState([]);
  const [dataCol2, setDataCol2] = useState([]);
  const [checkList, setCheckList] = useState({});
  const [resolutionImages, setResolutionImages] = useState([]);
  const [resolutionDetails, setResolutionDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { status } = useContext(StatusContext);
  const contentRef = useRef(null);
  const pdfExportComponent = useRef(null);
  const printButtonRef = useReactToPrint({
    content: () => contentRef.current,
    documentTitle: "Job Card",
  });

  const {
    mutate: getJobCards,
    data: jobCardsRes,
    isPending: loadingJobCards,
    error: jobCardsError,
    reset: resetJobCards,
  } = useGetPanicAlertJobCards();
  const formatDurations = (duration) => {
    let time = null;
    if (duration) {
      const durationArray = duration.split(":");
      const days = Math.floor(Number(durationArray[0]) / 24);
      const hours = moment(Number(durationArray[0]) % 24, "hh").format("HH");
      const minutes = moment(durationArray[1], "m").format("mm");
      const seconds = moment(durationArray[2], "s").format("ss");
      time = `${days > 10 ? days : `0${days}`}d ${hours}h ${minutes}m ${seconds}s`;
    }

    return time;
  };
  const API_URL = process.env.REACT_APP_API_URL;
  const IS_LOCAL =
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === "true" ||
    process.env.REACT_APP_LOCAL_FILE_SYSTEM === true;
  const user = useUser();

  useEffect(() => {
    const data = jobCardDetails;
    if (data?.uploadedFiles) {
      const _resolutionImages = [];
      data.uploadedFiles.forEach((elm) => {
        if (
          elm.fileName !== "Machine picture after service completion" &&
          elm.fileName !== "Assignee Signature" &&
          elm.fileName !== "Machine picture before service start"
        ) {
          _resolutionImages.push({
            ...elm,
            type:
              elm.fileName === "Service_Video_Recording.mp4"
                ? "recording"
                : "image",
          });
        }
      });
      setResolutionImages(_resolutionImages);
    }
  }, [jobCardDetails]);
  useEffect(() => {
    if (jobCardsRes) {
      const data = {
        ...jobCardsRes.data,
        acknowlegedIn: formatDurations(jobCardsRes.data.acknowlegedIn),
        actualTravelTime: formatDurations(jobCardsRes.data.actualTravelTime),
        allocationTime: formatDurations(jobCardsRes.data.allocationTime),
        attendedTime: formatDurations(jobCardsRes.data.attendedTime),
        serviceStartedIn: formatDurations(jobCardsRes.data.serviceStartedIn),
        taskCompletedIn: formatDurations(jobCardsRes.data.taskCompletedIn),
        tripStartedIn: formatDurations(jobCardsRes.data.tripStartedIn),
        onHoldDuration: formatDurations(jobCardsRes.data.onHoldDuration),
      };

      data.checkList.pop();
      console.log("Data:", data);
      const uploadedFiles = [];
      let uploadedFilesConversionCount = 0;
      if (!data.uploadedFiles || data.uploadedFiles?.length === 0) {
        setLoading(false);
        setJobCardDetails(data);
      }

      data.uploadedFiles.forEach((elm, index) => {
        http
          .get(
            IS_LOCAL
              ? `${API_URL}/common/download/local?path=${elm.filePath}`
              : `${API_URL}/common/download/cloud?url=${elm.filePath}`,
            {
              responseType: "blob",
            },
          )
          .then((response) => {
            const fileBlob = response.data;

            // eslint-disable-next-line no-console
            console.log("MIME Type:", fileBlob.type);

            uploadedFilesConversionCount += 1;
            const blob = new Blob([response.data], { type: fileBlob.type });

            const url = URL.createObjectURL(blob);
            elm.filePath = url;
            uploadedFiles[index] = elm;
            if (data.uploadedFiles.length === uploadedFilesConversionCount) {
              data.uploadedFiles = uploadedFiles;
              setJobCardDetails(data);
              setLoading(false);
            }
          })
          .catch(() => {
            uploadedFilesConversionCount += 1;
            if (data.uploadedFiles.length === uploadedFilesConversionCount) {
              data.uploadedFiles = uploadedFiles;
              setJobCardDetails(data);
              setLoading(false);
            }
          });
      });

      resetJobCards();
    }

    if (jobCardsError) {
      sweetAlert({
        title: "Operation Failure!!",
        text: "Job card not available",
        icon: "error",
      });
      resetJobCards();
    }
  }, [jobCardsRes, jobCardsError]);
  useEffect(() => {
    if (params.ticketId) {
      getJobCards(params.ticketId);
      setLoading(true);
    }
  }, []);

  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  const hasATMSnapShot = useMemo(() => {
    if (jobCardDetails.uploadedFiles?.length === 0) return null;
    const imageIndex = jobCardDetails.uploadedFiles?.findIndex(
      (elm) => elm.fileName === "Machine picture before service start",
    );
    if (imageIndex !== -1 && imageIndex !== undefined)
      return jobCardDetails.uploadedFiles[imageIndex].filePath;
    return null;
  }, [jobCardDetails]);
  const hasATMAfterSnapShot = useMemo(() => {
    if (jobCardDetails.uploadedFiles?.length === 0) return null;
    const imageIndex = jobCardDetails.uploadedFiles?.findIndex(
      (elm) => elm.fileName === "Machine picture after service completion",
    );
    if (imageIndex !== -1 && imageIndex !== undefined)
      return jobCardDetails.uploadedFiles[imageIndex].filePath;
    return null;
  }, [jobCardDetails]);
  const hasSignature = useMemo(() => {
    if (jobCardDetails.uploadedFiles?.length === 0) return null;
    const imageIndex = jobCardDetails.uploadedFiles?.findIndex(
      (elm) => elm.fileName === "Assignee Signature",
    );
    if (imageIndex !== -1 && imageIndex !== undefined)
      return jobCardDetails.uploadedFiles[imageIndex].filePath;
    return null;
  }, [jobCardDetails]);
  const getHomeURL = useGetParentTicketList(status);

  return (
    <>
      {loadingJobCards || loading ? <Loader /> : <></>}
      <div className="form-container">
        <BreadCrumb
          items={[
            { to: getHomeURL, text: "Tickets" },
            {
              to: `${PATHS.panicAlertDetails}/${isCallCenterAgent(user) ? jobCardDetails.ticketId : jobCardDetails.requestId}`,
              text: jobCardDetails.caseNo || "Parent",
            },
            {
              to: `${PATHS.panicAlertTaskDetails}/${jobCardDetails.requestId}`,
              text: jobCardDetails.taskNo || "Task",
            },
            {
              text: `Job Cards`,
            },
          ]}
        />
        <Card className="px-8 py-4 my-2 shadow-none rounded-lg  justify-end text-secondary flex flex-row gap-8">
          <BiPrinter
            fontSize="30px"
            className="cursor-pointer"
            title="Print Job Card"
            onClick={printButtonRef}
          />
          {/* <MdEmail
            fontSize={"30px"}
            className="cursor-pointer"
            title={"Email Job Card"}
          /> */}
          <BiDownload
            fontSize="30px"
            className="cursor-pointer"
            title="Download Job Card"
            onClick={exportPDFWithComponent}
          />
        </Card>
        <PDFExport
          ref={pdfExportComponent}
          paperSize="auto"
          margin={{ top: 40, left: 20, right: 20, bottom: 40 }}
          fileName={`Job Card for ${jobCardDetails.caseNo}-${jobCardDetails.taskNo}`}
          author="LYNX"
        >
          <Card
            className="form-card px-10 shadow-lg m-0"
            ref={contentRef}
            style={{ marginTop: 0 }}
          >
            <CardHeader className="flex flex-row justify-between">
              <CardTitle className="text-medium">
                Job Card {jobCardDetails.caseNo}/#{jobCardDetails.taskNo}
              </CardTitle>
              <div className="flex flex-row gap-3">
                <div className="flex flex-col gap-1">
                  <h1 className="text-sm font-bold">Created On</h1>
                  <p className="text-sm">{jobCardDetails.createDateTime}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <h1 className="text-sm font-bold ">Completed On</h1>
                  <p className="text-sm">{jobCardDetails.completionDateTime}</p>
                </div>
              </div>
            </CardHeader>
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              {/* <JobDetails
              jobCardDetails={jobCardDetails}
              // ref={(el) => (componentRef = el)}
            /> */}
              <div>
                <table width="100%" align="top">
                  <thead>
                    <th width="40%" />
                    <th width="20%" />
                    <th width="40%" />
                  </thead>
                  <tbody>
                    <tr align="top">
                      <td className="flex">
                        <table
                          width="100%"
                          height="100%"
                          className="job-card text-sm"
                        >
                          <thead>
                            <td width="50%" />
                            <td width="50%" />
                          </thead>
                          <tbody>
                            <tr>
                              <td className="title">Task Increment Number</td>
                              <td className="value">{jobCardDetails.taskNo}</td>
                            </tr>
                            <tr>
                              <td className="title">Client</td>
                              <td className="value">
                                {jobCardDetails.customer}
                              </td>
                            </tr>

                            <tr>
                              <td className="title">Region</td>
                              <td className="value">{jobCardDetails.region}</td>
                            </tr>
                            <tr>
                              <td className="title">Configuration Items</td>
                              <td className="value">
                                {jobCardDetails.officeId}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td />
                      <td align="top" className="flex">
                        <table
                          width="100%"
                          height="100%"
                          align="top"
                          className="job-card text-sm"
                        >
                          <thead>
                            <td width="50%" />
                            <td width="50%" />
                          </thead>
                          <tbody>
                            <tr>
                              <td className="title">Location</td>
                              <td className="value">
                                {jobCardDetails.officeName}
                              </td>
                            </tr>
                            <tr>
                              <td className="title">Task Type</td>
                              <td className="value">Service Request</td>
                            </tr>
                            <tr>
                              <td className="title">Priority</td>
                              <td className="value">
                                {jobCardDetails.priority}
                              </td>
                            </tr>
                            <tr>
                              <td className="title">Description</td>
                              <td className="value">
                                {jobCardDetails.remarks}
                              </td>
                            </tr>
                            {/* <tr>
                              <td className="title">Additional Information</td>
                              <td className="value">
                                {jobCardDetails.remarks}
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "20px" }} />
                      <td />
                      <td />
                    </tr>
                    <tr>
                      <td>
                        <table width="100%" className="job-card text-sm">
                          <col width="50%" />
                          <col width="50%" />
                          <thead className="job-card-title">
                            <tr>
                              <th colSpan={2} className="p-[6px]">
                                Init Fields
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="title">Asset ID</td>
                              <td className="value">
                                {jobCardDetails.registrationNo}
                              </td>
                            </tr>
                            <tr>
                              <td className="title">Activity Type</td>
                              <td className="value">
                                {jobCardDetails.activityType}
                              </td>
                            </tr>
                            <tr>
                              <td className="title">Fault Category</td>
                              <td className="value">
                                {jobCardDetails.category}
                              </td>
                            </tr>
                            <tr>
                              <td className="title">Fault Sub Category</td>
                              <td className="value">
                                {jobCardDetails.subCategory}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td />
                      <table width="100%" className="job-card text-sm">
                        <col width="50%" />
                        <col width="50%" />
                        <thead className="job-card-title">
                          <tr>
                            <th colSpan={2} className="p-[6px]">
                              Init Fields
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="title">Assigned To</td>
                            <td className="value">
                              {jobCardDetails.primaryAssigneeName}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </tr>
                    <tr>
                      <td className="text-lg py-10 font-bold" colSpan={3}>
                        The following statistics are calculated for this task
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <table>
                          <thead>
                            <th width="48%" />
                            <th width="4%" />
                            <th width="48%" />
                          </thead>
                          <tbody>
                            <tr>
                              <td className="flex">
                                <table className="job-card text-sm">
                                  <tbody>
                                    <tr>
                                      <td className="title">
                                        Duration from when the task was
                                        allocated to the user to when the user
                                        accepted the task
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.acknowlegedIn ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="title">
                                        Duration from when the user accepted the
                                        task from when the user started
                                        traveling
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.tripStartedIn ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    {/* <tr>
                            <td
                              className="title"
                              
                            >
                              Expected travel time
                            </td>
                            <td className="value text-nowrap">
                              {jobCardDetails.acknowlegedIn ||
                                "00d 00h 00m 00s"}
                            </td>
                          </tr> */}
                                    <tr>
                                      <td className="title">
                                        Actual travel time
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.actualTravelTime ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="title">
                                        Actual travel duration from when the
                                        user stopped traveling to when the user
                                        started working
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.serviceStartedIn ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="title">
                                        Time spent executing work
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.taskCompletedIn ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                              <td />
                              <td className="flex">
                                <table className="job-card text-sm">
                                  <tbody>
                                    <tr>
                                      <td className="title">
                                        Duration from when the user accepted the
                                        task to when the user completed the task
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.attendedTime ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="title">
                                        Total duration from when the task was
                                        allocated to the user to when the user
                                        completed the task
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.allocationTime ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                    {/* <tr>
                            <td
                              className="title"
                              
                            >
                              Expected travel distance
                            </td>
                            <td className="value text-nowrap">
                              {jobCardDetails.acknowlegedIn ||
                                "00d 00h 00m 00s"}
                            </td>
                          </tr> */}

                                    <tr>
                                      <td className="title">
                                        On-hold duration
                                      </td>
                                      <td className="value text-nowrap">
                                        {jobCardDetails.onHoldDuration ||
                                          "00d 00h 00m 00s"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>

                    {/* {jobCardDetails.checkList?.length > 0 ? ( */}
                    <>
                      <tr>
                        <td className="text-lg py-10 font-bold" colSpan={3}>
                          Data captured for this task
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <table width="100%">
                            <thead>
                              <th width="48%" />
                              <th width="4%" />
                              <th width="48%" />
                            </thead>
                            <tbody>
                              <tr>
                                {jobCardDetails.checkList?.length > 0 ? (
                                  <>
                                    <td className="flex">
                                      <table
                                        className="job-card text-sm"
                                        width="100%"
                                      >
                                        <thead>
                                          <th width="50%" />
                                          <th width="50%" />
                                        </thead>
                                        <tbody>
                                          {jobCardDetails?.checkList?.map(
                                            (elm) => (
                                              <>
                                                <tr className="job-card-title">
                                                  <td
                                                    className="job-card-title"
                                                    style={{
                                                      borderRadius: "0",
                                                    }}
                                                    colSpan={2}
                                                  >
                                                    {elm.category}
                                                  </td>
                                                </tr>

                                                {elm.subList?.map((item) => (
                                                  <>
                                                    <tr>
                                                      <td className="title">
                                                        {item.activity}
                                                      </td>
                                                      <td className="value">
                                                        {item.response || "--"}
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td className="title">
                                                        Remarks:
                                                      </td>
                                                      <td className="value">
                                                        {item.remarks || "--"}
                                                      </td>
                                                    </tr>
                                                  </>
                                                ))}
                                              </>
                                            ),
                                          )}
                                        </tbody>
                                      </table>
                                    </td>
                                    <td />
                                  </>
                                ) : null}

                                <td className="flex w-full">
                                  <table
                                    className="job-card text-sm"
                                    width="100%"
                                  >
                                    <thead>
                                      <th width="50%" />
                                      <th width="50%" />
                                    </thead>
                                    <tbody>
                                      <tr className="job-card-title">
                                        <td
                                          className="job-card-title"
                                          style={{ borderRadius: "0" }}
                                          colSpan={2}
                                        >
                                          Resolution Details
                                        </td>
                                      </tr>

                                      <tr>
                                        <td className="title">
                                          Resolution Code
                                        </td>
                                        <td className="value">
                                          {jobCardDetails.resolutionCode}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="title">
                                          Resolution Notes
                                        </td>
                                        <td className="value">
                                          {jobCardDetails.resolutionDetails}
                                        </td>
                                      </tr>
                                      {hasATMAfterSnapShot !== null ? (
                                        <tr>
                                          <td className="title">
                                            Upload ATM snapshot after all the
                                            work has been completed
                                          </td>
                                          <td className="value">
                                            <a
                                              target="_blank"
                                              href={hasATMAfterSnapShot}
                                              rel="noopener"
                                            >
                                              <img
                                                className="w-20 h-20 object-cover cursor-pointer"
                                                src={hasATMAfterSnapShot}
                                                alt=""
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      ) : (
                                        <></>
                                      )}
                                      {hasSignature !== null ? (
                                        <tr>
                                          <td className="title">Signature</td>
                                          <td className="value">
                                            <a
                                              target="_blank"
                                              href={hasSignature}
                                              rel="noopener"
                                            >
                                              <img
                                                className="w-20 h-20 object-cover cursor-pointer"
                                                src={hasSignature}
                                                alt=""
                                              />
                                            </a>
                                          </td>
                                        </tr>
                                      ) : (
                                        <></>
                                      )}
                                      {resolutionImages.map((elm, index) => (
                                        <tr key={index}>
                                          <td className="title">
                                            {elm.fileName}
                                          </td>
                                          <td className="value">
                                            {elm.type === "image" ? (
                                              <a
                                                target="_blank"
                                                href={elm.filePath}
                                                rel="noopener"
                                              >
                                                <img
                                                  className="w-20 h-20 object-cover cursor-pointer"
                                                  src={elm.filePath}
                                                  alt=""
                                                />
                                              </a>
                                            ) : (
                                              <Button
                                                onClick={(e) => {
                                                  e.preventDefault();

                                                  const newElm =
                                                    document.createElement("a");
                                                  newElm.href = elm.filePath;
                                                  newElm.setAttribute(
                                                    "download",
                                                    "Service Video Recording.mp4",
                                                  );
                                                  document.body.appendChild(
                                                    newElm,
                                                  );

                                                  newElm.click();
                                                  URL.revokeObjectURL(
                                                    newElm.href,
                                                  );
                                                  document.body.removeChild(
                                                    newElm,
                                                  );
                                                }}
                                                style={{
                                                  whiteSpace: "pre-wrap",
                                                  maxWidth: "200px",
                                                  color: "blue",
                                                  textDecoration: "underline",
                                                  padding: 0,
                                                  background: "transparent",
                                                  border: "0px",
                                                }}
                                              >
                                                Click to download
                                              </Button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </>
                    {/* ) : (
                      <></>
                    )} */}

                    <tr>
                      <td colSpan={3} className="text-lg py-10 font-bold" />
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <table width="100%">
                          <thead>
                            <th width="70%" />
                            <th width="30%" />
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <table
                                  width="100%"
                                  className="job-card text-sm"
                                  style={{ border: 0 }}
                                >
                                  <thead>
                                    <tr>
                                      <th width="30%" />
                                      <th
                                        width="70%"
                                        className="job-card-title"
                                      >
                                        Task Timeline
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {jobCardDetails.logs?.map((log, index) => (
                                      <tr key={`log-${index}`}>
                                        <td className="title border-l-2">
                                          {log.operation}
                                        </td>
                                        <td className="value border-r-2">
                                          <div className="flex flex-col gap-2 text-sm">
                                            <p>
                                              Created At: {log.operationTime}
                                            </p>
                                            <p>Location: {log.coordinates}</p>
                                            {log.operation === "Allocated" ? (
                                              <p>
                                                Created State: {log.remarks}
                                              </p>
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                              <td />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* <ReactToPrint
              trigger={() => {
                return (
                  <div className="w-full flex flex-row justify-end">
                    <Button variant={"secondary"}>Print Job Card</Button>
                  </div>
                );
              }}
              content={() => componentRef}
              pageStyle="print"
              onAfterPrint={closePrintModel}
              documentTitle="Job Card"
            /> */}
            </CardContent>
          </Card>
        </PDFExport>
      </div>
    </>
  );
}
